import React from 'react';

import Tippy from '@tippyjs/react';

import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';
import Typography from 'components/shared/Typography/Typography';

import 'tippy.js/dist/tippy.css';

const TOOLTIP_CONTENT = {
  standard: {
    example: 'Example:',
    multiplier: '• Multiplier is set to: 200%',
    service: '• Service: 99212 — Established patient office visit (10 - 19 min)',
    medicare: '• Medicare allowable: $40.54',
    calculated: '• Calculated price: $81.08',
    formula: '200% x $40.54 = $81.08'
  }
};

const PriceAdjustments = ({
  standardChargeMultiplier,
  selfPayMultiplier,
  onStandardChargeChange,
  onSelfPayChange
}) => {
  const TooltipContent = () => (
    <div className="text-left">
      <div>{TOOLTIP_CONTENT.standard.example}</div>
      <div>{TOOLTIP_CONTENT.standard.multiplier}</div>
      <div>{TOOLTIP_CONTENT.standard.service}</div>
      <div>{TOOLTIP_CONTENT.standard.medicare}</div>
      <div>{TOOLTIP_CONTENT.standard.calculated}</div>
      <div className="mt-2">{TOOLTIP_CONTENT.standard.formula}</div>
    </div>
  );

  return (
    <div>
      <div className="mb-2 text-base font-medium text-neutral-900">Service price adjustments</div>
      <div className="mb-4 text-sm text-neutral-700">
        Adjust service prices by applying percentage-based multipliers to Medicare allowable
        amounts. Prices update in real time as you enter values.
      </div>
      <div className="flex items-start gap-6">
        <div className="flex flex-1 flex-col gap-1">
          <div className="flex items-center justify-between">
            <Typography className="text-sm font-medium text-neutral-900">
              Standard charge multiplier
            </Typography>
            <Tippy content={<TooltipContent />}>
              <span className="inline-flex cursor-pointer">
                <Icon icon="info-circle-mono" size={16} color="neutral" shade={500} />
              </span>
            </Tippy>
          </div>
          <Input
            className="w-full"
            value={standardChargeMultiplier}
            actionButtonText="%"
            name="standardChargeMultiplier"
            onChange={onStandardChargeChange}
            placeholder="0"
          />
        </div>
        <div className="flex flex-1 flex-col gap-1">
          <div className="flex items-center justify-between">
            <Typography className="text-sm font-medium text-neutral-900">
              Self pay multiplier
            </Typography>
            <Tippy content={<TooltipContent />}>
              <span className="inline-flex cursor-pointer">
                <Icon icon="info-circle-mono" size={16} color="neutral" shade={500} />
              </span>
            </Tippy>
          </div>
          <Input
            className="w-full"
            value={selfPayMultiplier}
            actionButtonText="%"
            name="selfPayMultiplier"
            onChange={onSelfPayChange}
            placeholder="0"
          />
        </div>
      </div>
    </div>
  );
};

export default PriceAdjustments;
